import { observable, action } from "mobx";

import { post, get } from "../services/ajax.service"

class BrokerIndexStore {
    @observable broker_summary = [];
    @observable broker_summary_temp = [];
    @observable single_broker = [];
    @observable pbm = [];
    @observable reportError = "";
    @observable broker_details = {};
    @observable entities = [];
    @observable url = "/api/v1/brokerindexactions"
    @observable filterValue = "";

    @action sortbyasc(filter) {
        this.filterValue = filter;
        if (this.broker_summary.length > 0) {

            if (filter == "group_name") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.group_name < (b.group_name)) return -1;
                    if ((a.group_name) > (b.group_name)) return 1;
                    return 0
                })
            }
            if (filter == "file_received_pharmacy") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.last_file_received_date < (b.last_file_received_date)) return -1;
                    if ((a.last_file_received_date) > (b.last_file_received_date)) return 1;
                    return 0
                })
            }
            if (filter == "file_loaded_pharmacy") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.last_file_loaded_date < (b.last_file_loaded_date)) return -1;
                    if ((a.last_file_loaded_date) > (b.last_file_loaded_date)) return 1;
                    return 0
                })
            }
            if (filter == "file_received_med") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.last_file_received_date_medical < (b.last_file_received_date_medical)) return -1;
                    if ((a.last_file_received_date_medical) > (b.last_file_received_date_medical)) return 1;
                    return 0
                })
            }
            if (filter == "file_loaded_med") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.last_file_loaded_date_medical < (b.last_file_loaded_date_medical)) return -1;
                    if ((a.last_file_loaded_date_medical) > (b.last_file_loaded_date_medical)) return 1;
                    return 0
                })
            }
        }
    }

    @action sortbydesc(filter) {
        this.filterValue = filter;
        if (this.broker_summary.length > 0) {

            if (filter == "group_name") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if ((a.group_name) > (b.group_name)) return -1;
                    if ((a.group_name) < (b.group_name)) return 1;
                    return 0
                })
            }
            if (filter == "file_received_pharmacy") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.last_file_received_date > (b.last_file_received_date)) return -1;
                    if ((a.last_file_received_date) < (b.last_file_received_date)) return 1;
                    return 0
                })
            }
            if (filter == "file_loaded_pharmacy") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.last_file_loaded_date > (b.last_file_loaded_date)) return -1;
                    if ((a.last_file_loaded_date) < (b.last_file_loaded_date)) return 1;
                    return 0
                })
            }
            if (filter == "file_received_med") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.last_file_received_date_medical > (b.last_file_received_date_medical)) return -1;
                    if ((a.last_file_received_date_medical) < (b.last_file_received_date_medical)) return 1;
                    return 0
                })
            }
            if (filter == "file_loaded_med") {
                this.broker_summary = this.broker_summary.sort(function (a, b) {
                    if (a.last_file_loaded_date_medical > (b.last_file_loaded_date_medical)) return -1;
                    if ((a.last_file_loaded_date_medical) < (b.last_file_loaded_date_medical)) return 1;
                    return 0
                })
            }
        }
    }


    @action get_broker_summary = async (data) => {
        this.broker_summary = []
        const response = await post(`${this.url}/getGroupSummary`, data);
        this.broker_summary = this.broker_summary_temp = response.data

        if (data.flag) {
            this.broker_summary = [];
            this.broker_summary_temp.map(obj => {
                if (obj.group_name.toLowerCase().includes(data.search.toLowerCase())) {
                    this.broker_summary.push(obj);
                }
            })
        }
    }
    @action getGroupSummaryPBMCount = async (data) => {
        const response= await post(`${this.url}/getGroupSummaryPBMCount`,data);
        return response.data;
    }
    @action getGroupDetails = async (data) => {
        this.broker_details = {};
        const response = await post(`${this.url}/getGroupDetails`, data);
        this.broker_details = response.data
    }
    @action getSingleBroker = async (data) => {
        this.single_broker = [];
        const response = await post(`${this.url}/getSingleBroker`, data);
        this.single_broker = response.data
    }
    @action getAllPBM = async (data) => {
        this.pbm = [];
        const response = await post(`${this.url}/getAllPBM`,data);
        this.pbm = response.data
    }
    @action getEntitiesForBob = async () => {
        try{
            this.entities = [];
            const response = await get(`${this.url}/getEntitiesForBob`);

            this.entities = response.data.entities;
            return this.entities;
        } catch (e) {
            this.reportError = e.response.data;
            return []
        }


    }

    @action getBrokerNamesCSV = async (data) => {
        this.reportError = "";
        try {
            await post(`${this.url}/getBrokerNames`, data);
            return true;
        } catch (e) {
            this.reportError = e.response.data;
            return false
        }
    }

}

export default BrokerIndexStore;
